import * as React from "react";

import { cn } from "@/lib/utils";

/** `auth`: minimal chrome so `.input-auth` (components layer) is not overridden by default input utilities. */
const inputVariantClasses = {
  default:
    "flex h-9 w-full rounded-md border border-[var(--form-control-border)] bg-background px-3 py-1 text-base text-foreground shadow-[0_1px_2px_rgba(0,0,0,0.06)] transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
  // Do not set h-, p-, border-, rounded-, or bg- here: those are utilities and would
  // override `.input-auth` (@layer components), collapsing fields to thin strips.
  auth: "flex w-full text-base shadow-none transition-colors file:border-0 file:bg-transparent focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
} as const;

export type InputProps = React.ComponentProps<"input"> & {
  variant?: keyof typeof inputVariantClasses;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariantClasses[variant], className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
